/* oxlint-disable react/react-compiler -- Existing code is not yet compatible with React Compiler checks. */
import * as React from 'react';

/**
 * A custom hook that returns a persistent value.
 * It keeps the truethy value across renders.
 * @param value The value to persist.
 * @returns The persistent value.
 */
export function usePersistentValue<T>(value: T): T {
    const ref = React.useRef<T>(value);
    React.useLayoutEffect(() => {
        if (value) {
            ref.current = value;
        }
    }, [value]);
    return value ?? ref.current;
}
